<template>
  <el-dialog
    :visible.sync="dialogMsg.dialogArticle"
    width="30%"
    :before-close="addArticleBack"
  >
    <el-row>
      <el-col :span="24">
        <el-input v-model="addMsg.name" placeholder="请输入文章题目">
        </el-input>
      </el-col>
      <el-col :span="10">
        <el-input v-model="addMsg.author" placeholder="请输入作者名称">
        </el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="10">
        <el-input v-model="addMsg.organizer" placeholder="请输入出版杂志">
        </el-input>
      </el-col>
      <el-col :span="10">
        <el-input v-model="addMsg.orderNum" placeholder="输入卷号期号">
        </el-input>
      </el-col>
      <el-col :span="12">
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          placeholder="输入摘要"
          v-model="addMsg.intro"
        >
        </el-input>
        <!-- <el-in put v-model="addMsg.author" placeholder=""> </el-input> -->
      </el-col>
      <el-col :span="12">
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          placeholder="输入推荐理由"
          v-model="addMsg.recommendReason"
        >
        </el-input>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="addArticleBack">取 消</el-button>
      <el-button
        type="primary"
        v-if="dialogMsg.kind != 'update'"
        @click="addArticleOK"
        >添 加</el-button
      >
      <el-button
        type="primary"
        v-if="dialogMsg.kind == 'update'"
        @click="addArticleOK"
        >修 改</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: { dialogMsg: Object, dialogItem: Object },
  data() {
    return {
      addMsg: {},
    };
  },
  watch: {
    dialogItem(val, oldVal) {
      this.addMsg = JSON.parse(JSON.stringify(val))
    },
    immediate: true,
    deep: true,
  },
  methods: {
    addArticleBack() {
      this.$emit("addArticleBack", false);
      this.addMsg={}
    },
    addArticleOK() {
      this.$emit("addArticleOK", this.addMsg);
      this.addMsg={}
    },
  },
};
</script>
<style lang="scss" scoped>
.el-col {
  margin-bottom: 20px;
}
/deep/ .el-dialog__body{padding: 30px;}
.el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: center;
      .el-button--default:hover {
        background: $base-color;
        color: $blueBtna;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogArticles.vue